import { Modal, Button, Message } from '@arco-design/web-react'
import { useTranslation } from 'react-i18next'

interface SystemTokenModalProps {
  visible: boolean
  token: string
  onClose: () => void
}

export default function SystemTokenModal({ visible, token, onClose }: SystemTokenModalProps) {
  const { t } = useTranslation()

  const copy = () => {
    void navigator.clipboard.writeText(token).then(() => Message.success(t('personal.token.copied')))
  }

  return (
    <Modal title={t('personal.token.modalTitle')} visible={visible} onCancel={onClose} footer={null}>
      <p className="text-sm text-[var(--console-text-muted)] mb-3">{t('personal.token.modalHint')}</p>
      <code className="block p-3 rounded-lg bg-[var(--console-page-bg)] border border-[var(--console-border)] text-xs break-all">
        {token}
      </code>
      <div className="mt-4 flex justify-end gap-2">
        <Button onClick={copy}>{t('personal.token.copy')}</Button>
        <Button type="primary" onClick={onClose}>OK</Button>
      </div>
    </Modal>
  )
}
